var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconElectricalServicesBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4EF54CF3-801E-4937-8F1D-18610539B64C@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCC6-Make-a-reservation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-729.000000, -1227.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "electrical_services_black_24dp-copy",
    transform: "translate(729.000000, 1227.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 4.000000)",
    fill: "#353535",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,10 C18,9.45 17.55,9 17,9 L15,9 L15,11 L17,11 C17.55,11 18,10.55 18,10 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,13 L15,13 L15,15 L17,15 C17.55,15 18,14.55 18,14 C18,13.45 17.55,13 17,13 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,8 L11,8 C9.9,8 9,8.9 9,10 L8,10 C7.45,10 7,10.45 7,11 L7,13 C7,13.55 7.45,14 8,14 L9,14 C9,15.1 9.9,16 11,16 L13,16 C13.55,16 14,15.55 14,15 L14,9 C14,8.45 13.55,8 13,8 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,9 C2,7.9 2.9,7 4,7 L5.5,7 C7.43,7 9,5.43 9,3.5 C9,1.57 7.43,0 5.5,0 L2,0 C1.45,0 1,0.45 1,1 C1,1.55 1.45,2 2,2 L5.5,2 C6.33,2 7,2.67 7,3.5 C7,4.33 6.33,5 5.5,5 L4,5 C1.79,5 0,6.79 0,9 C0,11.21 1.79,13 4,13 L6,13 L6,11 L4,11 C2.9,11 2,10.1 2,9 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElectricalServicesBold);
export default __webpack_public_path__ + "static/media/icon_electrical_services_bold.4c5b29c6ec0145f5dbbad91e7f26bfd6.svg";
export { ForwardRef as ReactComponent };